export { AlertComponent } from './alert.component';
export { AlertModule } from './alert.module';
export { AlertConfig } from './alert.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/alert/index.js
// module id = 461
// module chunks = 10